import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FormHeader from './components/FormHeader';
import FormTextField from './components/FormTextField';
import YearSelector from './components/YearSelector';
import BloodGroup from './components/BloodGroup';
import PreferredHand from './components/PreferredHand';
import FormFoot from './components/FormFoot';
import { handleFieldChange } from './helpers/HandleFieldChange';
import '../styles/OnlineForm.css';
import '../styles/TextField.css';
import '../styles/FormHeader.css';
import '../styles/FormFoot.css';

const OnlineForm = ({ language, formData, setFormData, onNextPage }) => {
  const { t } = useTranslation();
  
  const [errors, setErrors] = useState({});
  const [lastPhoneIndex, setLastPhoneIndex] = useState(0);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const handlePhoneChange = (value, index) => {
    const newPhones = [...formData.phones];
    newPhones[index] = value.trim();
    setFormData({ ...formData, phones: newPhones });
  };

  const addPhoneField = () => {
    if (formData.phones.length < 2) {
      setFormData({ ...formData, phones: [...formData.phones, ''] });
      setLastPhoneIndex(lastPhoneIndex + 1);
    }
  };

  const removePhoneField = (index) => {
    if (formData.phones.length > 1) { // Verificar que haya más de un teléfono antes de eliminar
      const newPhones = [...formData.phones];
      newPhones.splice(index, 1);
      setFormData({ ...formData, phones: newPhones });
      if (lastPhoneIndex === index) {
        setLastPhoneIndex(lastPhoneIndex - 1); // Decrementar el índice del último teléfono agregado solo si el eliminado es el último
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let formErrors = {};

    formErrors = handleError(formData);

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      onNextPage();
    }
  };

  return (
    <>
    <FormHeader
      language={language} />
    <form className='mainFormContainer' onSubmit={handleSubmit}>
    <h3 style={{fontWeight: 'lighter'}}>{t('form.optionalDataWording')}</h3>
      <FormTextField
        label={t('form.name')}
        name="name"
        value={formData.name}
        onChange={(value) => handleFieldChange(formData, setFormData, 'name', value)}
        error={errors.name}
      />
      <br />
      <FormTextField
        label={t('form.lastName')}
        name="lastName"
        value={formData.lastName}
        onChange={(value) => handleFieldChange(formData, setFormData, 'lastName', value)}
        error={errors.lastName}
      />
      <br />
      <YearSelector
        value={formData.dateOfBirth}
        onChange={(value) => handleFieldChange(formData, setFormData, 'dateOfBirth', value)}
        error={errors.dateOfBirth}
        />
      <br />
      <BloodGroup 
        value={formData.bloodGroup} 
        onChange={(value) => handleFieldChange(formData, setFormData, 'bloodGroup', value)}
        error={errors.bloodGroup}
      />
      <br />
      <PreferredHand
        value={formData.preferredHand}
        onChange={(value) => handleFieldChange(formData, setFormData, 'preferredHand',value)}
        error={errors.preferredHand}
      />
      <br />
        {formData.phones.map((phone, index) => (
          <div key={index} className="formFieldContainerPhone">
            {index === 0 && (
              <label className='formLabel'>
                  {t('form.phones')} #{index+1}
              </label>
            )}
            {index === 1 && (
              <label className='formLabel'>
                  {t('form.phonesNotObligatory')} #{index+1}
              </label>
            )}
            <label className='formLabelSmall'>{t('form.codeArea')}</label>
            <div className="phoneInputWrapper">
              <input
                className='textField-select'
                type="text"
                value={phone}
                onChange={(e) => handlePhoneChange(e.target.value, index)}
              />
              {index === lastPhoneIndex && (
                <>
                  {formData.phones.length === 1 && (
                    <button type="button" className='addRemoveBtn' onClick={addPhoneField}>+</button>
                  )}
                  {formData.phones.length > 1 && (
                    <button type="button" className='addRemoveBtn' onClick={() => removePhoneField(index)}>-</button>
                  )}
                </>
              )}
            </div>
            
          {errors.phones && <span className="errorMessage">{errors.phones}</span>}
          </div>
        ))}
        <div className='next-div'>
          <button type="submit" className="square-button-next">
            <span className="button-text">{t('form.next')}</span>
          </button>
        </div>
    </form>
    <FormFoot
      language={language} />
    </>
  );

  function handleError(formData) {
    const formErrors = {};

    if (!formData.name) formErrors.name = t('errors.nameError');

    if (formData.name && formData.name.length > 20) formErrors.name = t('errors.max10char');

    if (!formData.lastName) formErrors.lastName = t('errors.lastNameError');

    if (formData.lastName && formData.lastName.length > 20) formErrors.lastName = t('errors.max15char');

    if (!formData.dateOfBirth) formErrors.dateOfBirth = t('errors.dateOfBirthError');

    if (!formData.bloodGroup) formErrors.bloodGroup = t('errors.bloodGroupError');

    if (!formData.preferredHand) formErrors.preferredHand = t('errors.preferredHandError');

    if (formData.phones.length >= 1 && formData.phones[0] === "") formErrors.phones = t('errors.phoneError');

    if (formData.phones[0] && formData.phones[0].length > 15) formErrors.phones = t('errors.max15char');

    if (formData.phones[1] && formData.phones[1].length > 15) formErrors.phones = t('errors.max15char');

    if (!/^[\p{L}\s'"]*$/u.test(formData.name)) formErrors.name = t('errors.onlyLetters');

    if (!/^[\p{L}\s'"]*$/u.test(formData.lastName)) formErrors.lastName = t('errors.onlyLetters');

    // if (formData.phones.length >= 1){
    //   formData.phones.forEach((phone, _) => {
    //     if (!/^[a-zA-Z0-9]+$/.test(phone) && phone !== '') {
    //       formErrors.phones =  t('errors.onlyLettersNumbers');
    //     }
    //   });
    // }

    return formErrors;
}
};

export default OnlineForm;
